import { render } from "./InfoColumn.vue?vue&type=template&id=39c2eba8&scoped=true"
import script from "./InfoColumn.vue?vue&type=script&lang=js"
export * from "./InfoColumn.vue?vue&type=script&lang=js"

import "./InfoColumn.vue?vue&type=style&index=0&id=39c2eba8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c2eba8"]])

export default __exports__